import { motion } from "framer-motion";
const AbsoluteImage = ({ src = "", styles = "" }) => {
  return (
    <>
      <motion.div className={`absolute ${styles} -z-30`}>
        <img src={src} alt="grid" className="w-full h-full object-contain" />
      </motion.div>
    </>
  );
};
export default AbsoluteImage;
